import React from 'react'
import './HomeDummy.css'


const HomeDummy = () => {
    return (<>
        <div className='container'>
            <div className='box-second'></div>


            <div className='box-container'>
                <div className='box-third1' />
                <div className='box-third2' />
                <div className='box-third2' />
                <div className='box-third3' />
                <div className='box-third1' />


            </div>


        </div>
    </>
    )
}

export default HomeDummy